import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    token: '',
    iosDialog: false,
    iosDialogNeverAgain: localStorage.getItem('dialog') || false,
    user: JSON.parse(sessionStorage.getItem('user')) || null,
    token: sessionStorage.getItem('token') || null,
    connection: null,
    object: null,
    tempObject: null,
    loggingOut: false,
    permissionDenied: false,
    sound: null,
    ratingDialog: false
  },
  getters: {
    isAuth: state => !!state.user
  },
  mutations: {
    setRatingDialog(state, value){
      state.ratingDialog = value
    },
    setSound(state, sound){
      state.sound=sound
    },
    noPermission(state){
      state.permissionDenied=true
    },
    setConnection(state, connection) {
      state.connection = connection
    },
    setObject(state, object) {
      state.object = object
    },
    setTempObject(state, tempObject){
      state.tempObject = tempObject
    },
    dialog(state) {
      console.log(localStorage.getItem('dialog'))
      if (localStorage.getItem('dialog') !== 'true') {
        state.iosDialog = true
        console.log('into if')
      }
    },
    closeDialog(state, value) {
      state.iosDialog = false
      localStorage.setItem('dialog', value)
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    tokenRegister(state, token) {
      state.token = token
    },
    login(state, user) {
      state.user = user.user,
      sessionStorage.setItem('user', JSON.stringify(user.user))

      state.token = user.token
      sessionStorage.setItem('token', user.token)
    },

    setUser(state, user){
      state.user = user,
      sessionStorage.setItem('user', JSON.stringify(user))
    },

    editProfile(state, user){
      state.user = user,
      sessionStorage.setItem('user', JSON.stringify(user))
    },

    setCurrentAvailability(state, data) {
      state.user.isCurrentlyAvailable = data,
        sessionStorage.setItem('user', JSON.stringify(state.user))

    },

    logout(state) {
      state.user = null
      sessionStorage.removeItem('user')

      state.token = null
      sessionStorage.removeItem('token')

      delete axios.defaults.headers.common['Authorization']
    },
    setLoggingOut(state, value){
      state.loggingOut = value
    }
  },
  actions: {
    setRatingDialog({commit},value){
      commit('setRatingDialog',value)
    },
    setSound({commit},sound){
      commit('setSound',sound)
    },
    noPermission({commit}){
      commit('noPermission')
    },
    setConnection({ commit }, connection) {
      return new Promise((resolve, reject) => {
        commit('setConnection', connection)
        resolve(connection)
      })

    },
    setObject({ commit }, object) {
      return new Promise((resolve, reject) => {
        commit('setObject', object)
        resolve()
      })
    },
    setTempObject({commit}, tempObject){
      return new Promise((resolve, reject) => {
        commit('setTempObject', tempObject)
        resolve()
      })
    },
    dialog({ commit }) {
      commit('dialog')
    },
    closeDialog({ commit }, value) {
      commit('closeDialog', value)
    },
    userRegister({ commit }, credentials) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}/user/register`, { ...credentials })
          .then(res => {
            commit('setLoading', false)
            commit('tokenRegister', res.data.token)
            resolve(res)
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },

    doctorProfile({ commit }, credentials) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}/doctor/doctorProfile`, credentials.obj, {
          headers: { Authorization: 'Bearer ' + credentials.token }
        })
          .then(res => {
            commit('setLoading', false)
            resolve(res)
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },

    agreeWithTerms({ commit }, token) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_BASE_URL}/user/agreeWithTerms`, {
          headers: { Authorization: 'Bearer ' + token }
        })
          .then(res => {
            commit('setLoading', false)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    verifyCode({ commit }, credentials) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}/user/verifyCode`, { verificationCode: credentials.verificationCode }, {
          headers: { Authorization: 'Bearer ' + credentials.token }
        })
          .then(res => {

            commit('setLoading', false)
            resolve(res)
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },

    login({ commit }, credentials) {
      commit('setLoading', true)
      let token
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}/user/login`, credentials)
          .then(res => {
            token = res.data.token
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            return axios.get(`${process.env.VUE_APP_BASE_URL}/doctor/myprofile`)
          })
          .then(res => {
            const data = {
              user: res.data,
              token: token
            }
            commit('login', data)
            commit('setLoading', false)

            resolve(data)
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },

    setUser({commit}){
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_BASE_URL}/doctor/myprofile`)
        .then(res => {
          commit('setUser', res.data)
          resolve()
        })
        .catch(err => {
          reject(err)
        })
      })
    },

    editProfile({commit}, credentials){
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}/doctor/doctorProfile`, credentials)
        .then(res => {
          commit('editProfile', res.data)
          commit('setLoading', false)
          resolve(res)
        })
        .catch(err => {
          commit('setLoading', false)
          reject(err)
        })
      })
    },

    setCurrentAvailability({ commit }, obj) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}/doctor/setCurrentAvailability`, obj)
          .then(res => {
            commit('setCurrentAvailability', res.data)
            commit('setLoading', false)
            resolve(res)
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },

    logout({ commit }) {
      commit('setLoggingOut',true)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}/doctor/setCurrentAvailability`, { isCurrentlyAvailable: false })
          .then(() => {
            return axios.post(`${process.env.VUE_APP_BASE_URL}/user/logout`, [localStorage.getItem('fcmToken')])
          
          })
          .then(res => {
            console.log(res)
            commit('setLoggingOut',false)
            commit('logout')
            resolve()
          })
          .catch(err => {
            console.log(err)
            commit('setLoggingOut',false)
          })

      })

    }
  },
  modules: {
  }
})
